export class BooleanHelper {
  static truthyVals: any[] = [1, '1', 'true', 'ok', 'yes', true];
  static toBoolean<T>(value: T): boolean {
    return this.truthyVals.includes(value);
  }
}
